<template>
  <div class="center-warp sales">
    <div class="inner">
      <div class="d-flex">
        <div class="top-search" style="padding-left: 15px">
<!--          <input type="text" v-model="queryParams.message" placeholder="输入关键字搜索" @keydown.enter="handleQuery">-->
          <Input :placeholder="'输入关键字搜索'" v-model="queryParams.message" @enter="handleQuery"/>
          <div class="iconfont icon-sousuo" @click="handleQuery"></div>
        </div>
        <el-date-picker class="date-item" v-model="queryParams.visit_time_between" start-placeholder="开始日期" end-placeholder="结束日期" type="daterange" value-format="yyyy.MM.dd" @change="handleQuery">
        </el-date-picker>
        <div class="reset-btn" @click="handleReset">重置</div>
      </div>
      <div class="add-btn" @click="handleAdd">+ 新增</div>
      <div class="box-table" v-loading="loading">
        <div class="box-table-tr box-table-head black-14">
          <div>序号</div>
          <div>走访记录</div>
          <div>创建时间</div>
          <div>操作</div>
        </div>
        <div class="box-table-tr black-14" v-for="(item, index) in list" :key="item.id">
          <div>{{ index + 1 }}</div>
          <div>{{item.message}}</div>
          <div>{{ item.visit_time2}}</div>
          <div>
            <span class="box-tr-send" @click="handleView(item)">查看</span>
            <!-- <span class="box-tr-del">删除</span> -->
          </div>
        </div>
        <Empty v-if="!list.length" :info="'暂无走访日志'" :img-width="'200px'" />
      </div>
      <Pagination :total="total" :page.sync="queryParams.page" :last_page="last_page" @pagination="getList" :key="queryParams.page" />
      <el-dialog :visible.sync="showAddDialog" custom-class="take-dialog" :title="form.id ? '查看走访记录' : '新增走访记录'" width="340px" :close-on-click-modal="false">
        <div class="edit-line d-flex-between">
          <div class="black-14">创建时间</div>
          <div style="width: 220px;margin-top: 12px">{{ workDate }}</div>
        </div>
        <div class="edit-line d-flex-between">
          <div class="black-14">走访记录</div>
          <textarea class="edit-textarea" :disabled="form.id" v-model="form.message" placeholder="填写走访记录"></textarea>
        </div>
        <div class="take-dialog-bottom" v-if="!form.id">
          <div class="take-dialog-close" @click="showAddDialog = false">取消</div>
          <div class="take-dialog-open" @click="submitForm">提交</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { visitLog, saveVisitLog } from "@/http/sales_custom";
import Pagination from "@/components/Pagination";
export default {
  name: "visit_records",
  components: { Pagination },
  data() {
    return {
      list: [],
      loading: "",
      queryParams: {
        page: 1,
        pageSize: 8,
        message: undefined,
        visit_time_between: []
      },
      total: 0,
      last_page: 0,
      showAddDialog: false,
      form: {
        message: undefined,
        member_id: this.doctor_id,
      },
      doctor_id: undefined,
      formLoading: false,
      workDate:""
    };
  },
  mounted() {
    this.$store.commit("breadChange", {
      name: this.$route.query.name + "医生的走访记录",
      isBack: true,
    });
    if (this.$route.query.doctor_id)
      this.doctor_id = this.$route.query.doctor_id;
    this.getList();
  },
  methods: {
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    getList() {
      this.loading = true
      if (this.doctor_id) {
        this.queryParams.doctor_id = this.doctor_id;
        visitLog(this.queryParams).then((res) => {
          this.loading = false
          this.list = res.data.data;
          this.total = res.data.total;
          this.last_page = res.data.last_page;
        });
      }
    },
    handleAdd() {
      this.initForm();
      this.workDate = new Date().toLocaleDateString()
      this.showAddDialog = true;
    },
    initForm() {
      this.form = {
        message: undefined,
        member_id: this.doctor_id,
      };
    },
    submitForm() {
      if (!this.form.member_id) {
        return this.$message.error("走访用户不能为空");
      }
      if (!this.form.message) {
        return this.$message.error("走访记录不能为空");
      }
      if (this.formLoading) {
        return;
      }
      this.formLoading = true;
      saveVisitLog(this.form)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "新增成功",
            });
          } else {
            this.$message.error(res.message[0] ? res.message[0] : "新增失败");
          }
          this.formLoading = false;
          this.showAddDialog = false;
          this.getList();
        })
        .catch(() => {
          this.formLoading = false;
          this.getList();
        });
    },
    handleView(item) {
      this.form = {
        id: item.id,
        message: item.message,
        visit_time2: item.visit_time2,
      };
      this.workDate = item.visit_time2
      this.showAddDialog = true;
    },
    handleReset() {
      this.queryParams.message = undefined;
      this.queryParams.visit_time_between = [];
      this.handleQuery();
    }
  },
};
</script>

<style scoped src="../../assets/css/visit_records.css">
</style>
<style>
.date-item{
  border: none;
  height: 32px;
  margin-left: 10px;
  border-radius: 6px;
}
.date-item input {
  height: 32px;
  border: none;
}
.date-item input::placeholder{
  color: rgba(60,60,67,0.3) !important;
}
.date-item .el-input__icon ,.date-item  .el-range-separator{
  line-height: 28px;
}
</style>
